<template>
  <v-container>
    <v-row>
      <v-col
        id="teste1"
        cols="12"
        sm="12"
        md="12"
        lg="4"
      >
        <div
          id="texto3"
          class="border1"
        >
          <h4
            id="titulo"
            class="text-center"
          >
            TOTAL QUEBRA
          </h4>
        </div>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div id="grafico2">
              <dashboard-grafico-total-quebra />
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="4"
      >
        <div
          id="texto4"
          class="border1"
        >
          <h4
            id="titulo"
            class="text-center"
          >
            TOTAL TROCA
          </h4>
        </div>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div id="grafico3">
              <dashboard-grafico-total-troca />
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="4"
      >
        <div
          id="texto5"
          class="border1"
        >
          <h4
            id="titulo"
            class="text-center"
          >
            TOTAL DEVOLUÇÕES
          </h4>
        </div>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div id="grafico3">
              <dashboard-grafico-total />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'ShowDashboardTiposDevolucoes',
    emits: [],
    components: {
      DashboardGraficoTotalQuebra: () => import('../../../graficos/ComercialPersonalizado/DevolucaoTotalQuebra'),
      DashboardGraficoTotalTroca: () => import('../../../graficos/ComercialPersonalizado/DevolucaoTotalTroca'),
      DashboardGraficoTotal: () => import('../../../graficos/ComercialPersonalizado/DevolucaoTotal'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleFaturamento: {
        color: '#C62828',
      },
    }),

    methods: {
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 720px) {
    .border1 {
      width: 15rem;
    }

    #texto3 {
      margin: 0 0 0 0rem;
      width: 28rem;
    }

    #texto4 {
      margin: 0 0 0 0rem;
      width: 28rem;
    }

    #texto5 {
      margin: 0 0 0 0;
      width: 28rem;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width: 1380px)
  and (max-width: 1901px) {
    .border1 {
      width: 21.5rem;
    }

    #texto3 {
      margin: -0.85rem 0 0 -13.7rem;
    }

    #texto4 {
      margin: -0.85rem 0 0 -10rem !important;
    }

    #texto5 {
      margin: -0.85rem 0 0 -6.2rem;
    }
  }

  @media screen
  and (min-width: 1902px) {
    .border1 {
      width: 26rem;
    }

    #texto3 {
      margin: -0.85rem 0 0 -16.15rem;
    }

    #texto4 {
      margin: -0.85rem 0 0 -11.7rem !important;
    }

    #texto5 {
      margin: -0.85rem 0 0 -7.2rem;
    }
  }
</style>

<style lang="sass">
  .border1
    border: inset
    width: 18rem

  #idLoading
    margin: 0 0 0 -15rem

  #idLoading1
    margin: 5rem 0 0 -10rem

  #texto1
    margin: 0 0 0 -1rem

  #texto3
    margin: -0.82rem 0 0 -11.8rem

  #texto4
    margin: -0.82rem 0 0 -8.55rem

  #texto5
    margin: -0.82rem 0 0 -5.3rem

  #titulo
    background: gray

</style>
